import { StepType } from '@/types/automationFields.ts';

const STEP_LEVEL_RETRY_SUPPORTED_STEP_TYPES = new Set<StepType>([
  StepType.TransformData,
  StepType.RunMetadata,
  StepType.CreateDirectory,
  StepType.GetFileFromDirectory,
  StepType.Filter,
  StepType.Validate,
]);

const STEP_LEVEL_RETRY_GUIDANCE_STEP_TYPES = new Set<StepType>([
  StepType.TransformData,
  StepType.GetFileFromDirectory,
  StepType.Filter,
  StepType.Validate,
]);

export const supportsStepLevelRetry = (stepType: StepType) => {
  return STEP_LEVEL_RETRY_SUPPORTED_STEP_TYPES.has(stepType);
};

export const supportsStepLevelRetryGuidance = (stepType: StepType) => {
  return STEP_LEVEL_RETRY_GUIDANCE_STEP_TYPES.has(stepType);
};
